export default "__VITE_ASSET__9dd00ed9__$_?nuxt_component=async&nuxt_component_name=SvgoWand__"